import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { STEPS } from "@/data/content";

export const HowItWorks = () => {
  return (
    <section className="relative overflow-hidden bg-background py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-primary/10 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-primary">
            Roadmap
          </span>
          <h2 className="section-title mt-4 text-foreground">
            How Can We Help You?
          </h2>
          <p className="mt-4 text-base text-muted-foreground md:text-lg">
            A clear, step-by-step path designed for job seekers. Real examples, mock setups, and templates you'll actually use.
          </p>
        </div>

        <div className="relative mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {/* Connecting line */}
          <div className="pointer-events-none absolute left-0 right-0 top-8 hidden h-px border-t border-dashed border-primary/30 lg:block" />

          {STEPS.map((step, i) => {
            const Icon = Icons[step.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={step.num}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.12 }}
                className="group relative flex flex-col rounded-2xl border border-border bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-primary/40 hover:shadow-md"
              >
                {/* Step number badge */}
                <span className="absolute -top-3.5 left-6 inline-flex items-center justify-center rounded-full bg-primary px-3 py-0.5 text-xs font-bold text-white shadow">
                  Step {step.num}
                </span>

                <span className="mt-3 inline-flex h-[52px] w-[52px] items-center justify-center rounded-xl bg-gradient-primary shadow">
                  <Icon className="h-6 w-6 text-white" />
                </span>
                <h3 className="mt-5 font-display text-lg font-bold text-foreground">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{step.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
